import React, { useEffect, useRef } from 'react';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { loadComeetScript, initComeet } from '../../../lib/comeet/loadComeetScript';
import type { ComeetEmbedConfig } from '../../../lib/comeet';
import { comeetApply } from './styles.ve.css';

interface ComeetApplyProps {
    positionUid: string;
    comeetEmbedConfig: ComeetEmbedConfig;
}

export const ComeetApply = ({ positionUid, comeetEmbedConfig }: ComeetApplyProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        const s = document.createElement('script');
        s.type = 'comeet-applyform';
        Object.assign(s.dataset, {
            cssCache: 'false',
            labelsPosition: 'top',
            fieldWebsite: 'false',
            fieldPortfolio: 'false',
            fieldQuestionnaires: 'false',
            fieldCoverletter: 'false',
            fieldPersonalnote: 'false',
            applyAsEmployee: 'false',
            thankyouUrl: pathfinder('jobs_page_jobs'),
            positionUid,
        });
        el.appendChild(s);
        loadComeetScript()
            .then(() => initComeet(comeetEmbedConfig))
            .catch(logger.error);
        return () => {
            el.replaceChildren();
        };
    }, [positionUid, comeetEmbedConfig]);

    return <div className={comeetApply} ref={ref} />;
};
